export const state = () => ({
  resources: [],
  viewMode: null,
  filters: {},
  resourcesToShow: null,
  options: {},
  totalRecordsFound: null
})

export const mutations = {
  setResources(state, newResources) {
    state.resources = newResources
  },

  addResources(state, newResources) {
    state.resources.push(...newResources)
  },

  removeResource(state, resourceToRemove) {
    const idx = state.resources.findIndex(resource => resource.id === resourceToRemove.id)
    state.resources.splice(idx, 1)
  },

  setViewMode(state, newViewMode) {
    state.viewMode = newViewMode
  },

  setFilters(state, newFilters) {
    state.filters = newFilters
  },

  setSelectOptions(state, { optionKey, options }) {
    state.options[optionKey] = [...options]
  },

  setResourcesToShow(state, newResources) {
    state.resourcesToShow = newResources
  },

  setTotalRecordsFound(state, newTotal) {
    state.totalRecordsFound = newTotal
  }
}

export const actions = {
  storeSearchResponse({ commit }, { response, viewMode, append, total }) {
    if (append) {
      commit('addResources', response)
    }
    else {
      commit('setResources', response)
    }
    commit('setViewMode', viewMode)
    commit('setTotalRecordsFound', total)
  },

  clean({ commit }) {
    commit('setResources', [])
    commit('setViewMode', null)
    commit('setResourcesToShow', null)
    commit('setTotalRecordsFound', null)
  }
}

export const getters = {
  resources: (state) => state.resources,
  resourcesCount: (state) => (state.resources || []).length,
  viewMode: (state) => state.viewMode,
  geoResponse: (state) => state.resources,
  filters: (state) => state.filters,
  options: (state) => state.options,
  optionsForKey: (state) => (optionKey) => state.options[optionKey] || [],
  resourcesToShow: (state) => state.resourcesToShow,
  totalRecordsFound: (state) => state.totalRecordsFound
}